import { SS_REF_HASH_ID } from "../../../presentation/resources/secureStorageManager";
import secureStorage from "../../../utility/secureStorage";
import {
  ApiGetServiceWithoutAuthenticationWrapper,
  ApiGetServiceWrapper,
  ApiGetServiceWrapperBlob,
} from "../wrapperService";
import { API_ENDPOINT } from "./ApiEndPoint";

export const ApiRequestGet = {
  getBalance: () => {
    return new Promise(async (resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      await ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client",
        headers: {
          "client-hash-id": refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getClientDetails: () => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client/details",
        headers: {
          "client-hash-id": refHashId,
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  checkUser: (email) => {
    return new Promise(async (resolve, reject) => {
      await ApiGetServiceWithoutAuthenticationWrapper({
        url: API_ENDPOINT.basePath + "authenticate/checkUser",
        headers: {
          email: email,
          role: "client",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // downloadVanTransaction: (
  //   page = 0,
  //   size = 10,
  //   dateRange = "",
  //   utr = "",
  //   van = ""
  // ) => {
  //   let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
  //   return new Promise((resolve, reject) => {
  //     console.log("van is dowb=nloadings");
  //     ApiGetServiceWrapper({
  //       url: API_ENDPOINT.basePath + "client/transactionDownload",
  //       headers: {
  //         "client-Hash-Id": refHashId,
  //         page,
  //         size,
  //         dateRange,
  //         transferUniqueNo: utr,
  //         beneAccountNo: van,
  //         // "Content-Type": "application/json",
  //       },
  //     })
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },

  downloadLedgerTransaction: (
    page = 0,
    size = 10,
    dateRange = "",
    type = "",
    id = ""
  ) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        url: API_ENDPOINT.basePath + "client/ledger/download",
        headers: {
          "client-Hash-Id": refHashId,
          page,
          size,
          dateRange,
          type: type?.toUpperCase(),
          utr: id,
          van: "",
        },
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  getTransactionsGraph: () => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client/transactionGraph",
        headers: {
          "client-Hash-Id": refHashId,
        },
      })
        .then((response) => resolve(response))
        .catch((error) => reject(error));
    });
  },
  getGeneratedReports: () => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client/generate/report",
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  scheduleJob: () => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client/schedule/job",
        headers: {
          "client-hash-id": refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  getCustomerBankDetails: ({ customerHashId }) => {
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "client/customer/bankDetails",
        headers: {
          customerHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getAllSchedules: () => {
    return new Promise((resolve, reject) => {
      let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
      ApiGetServiceWrapper({
        url: API_ENDPOINT.basePath + "transaction/report/schedule/jobs/list",
        headers: {
          clientHashId: refHashId,
        },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // ledgerDownload: (page = 0, size = 10, dateRange = "", utr = "", van = "") => {
  //   let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
  //   return new Promise((resolve, reject) => {
  //     ApiGetServiceWrapper({
  //       url: API_ENDPOINT.basePath + "client/report/center/download",
  //       headers: {
  //         page,
  //         size,
  //         dateRange,
  //         utr,
  //         van,
  //         "client-hash-id": refHashId,
  //       },
  //       blob: true,
  //     })
  //       .then((res) => resolve(res))
  //       .catch((err) => reject(err));
  //   });
  // },
  reportsDownload: (
    page = 0,
    size = 10,
    dateRange = "",
    transactionType = ""
  ) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        url: API_ENDPOINT.basePath + "client/report/center/download",
        headers: {
          page,
          size,
          dateRange,
          commissionType: "",
          type: "",
          "client-hash-id": refHashId,
          transactionType,
        },
        blob: true,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  payInPayutDownload: (
    page = 0,
    size = 10,
    dateRange = "",
    commissionType = ""
  ) => {
    let refHashId = secureStorage.getItem(SS_REF_HASH_ID);
    return new Promise((resolve, reject) => {
      ApiGetServiceWrapperBlob({
        url: API_ENDPOINT.basePath + "client/transactionDownload",
        headers: {
          page,
          size,
          dateRange,
          transferUniqueNo: "",
          beneAccountNo: "",
          "client-hash-id": refHashId,
          commissionType,
        },
        blob: true,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
